import { render, staticRenderFns } from "./total-score.component.vue?vue&type=template&id=33e0210a&scoped=true"
import script from "./total-score.component.vue?vue&type=script&lang=ts"
export * from "./total-score.component.vue?vue&type=script&lang=ts"
import style0 from "./total-score.component.vue?vue&type=style&index=0&id=33e0210a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e0210a",
  null
  
)

export default component.exports